import { bootstrap } from "@isocial-vue/blueprint";
import { module as RTWPModule } from "./index";

import App from "./components/App.vue";

// TODO add other CSS file needed to render rightly your app
import "@isocial-vue/blueprint/dist/blueprint.css";

import "./scss/reset.scss";

bootstrap(process.env, App, RTWPModule).then();
